import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import resetImg from 'src/assets/reset.png';
import logoSvg from 'src/assets/logo_pride.svg';
import lockSvg from 'src/assets/lock.svg';
import eyeSvg from 'src/assets/eye.svg';
import eyeOffSvg from 'src/assets/eye-off.svg';
import {
  Container,
  FormContainer,
  ImageContainer,
  Input,
  FooterText,
  LinkContainer,
  FooterContainer,
  FlexContainer,
  BackgroundImage,
  FormTitle,
  Logo,
  FooterLink,
  LoginInput,
  LockIcon,
  EyeIcon,
  AdministratorHeader,
  AdministratorHeaderText,
  ResetPassSubmitButton,
} from './styles';

const PasswordReset: React.FC = () => {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState<string>('password');
  const [isHidden, setIsHidden] = useState<string>('password');
  const [firstIcon, setFirstIcon] = useState<string>(eyeSvg);
  const [secIcon, setSecIcon] = useState<string>(eyeSvg);

  const handlePassword = (visible: string) => {
    setIsVisible(visible === 'password' ? 'text' : 'password');
    setFirstIcon(visible === 'password' ? eyeOffSvg : eyeSvg);
  };

  const handleConfirmPassword = (visible: string) => {
    setIsHidden(visible === 'password' ? 'text' : 'password');
    setSecIcon(visible === 'password' ? eyeOffSvg : eyeSvg);
  };

  return (
    <Container>
      <FormContainer>
        <AdministratorHeader>
          <AdministratorHeaderText>{t('login.form.adminHeader')}</AdministratorHeaderText>
        </AdministratorHeader>
        <FlexContainer>
          <Logo src={logoSvg} alt="Pride Global logo" />
          <FormTitle>{t('resetPassword.form.title')}</FormTitle>
          <LoginInput>
            <LockIcon src={lockSvg} />
            <Input type={isVisible} placeholder={t('resetPassword.form.password')} />
            <EyeIcon src={firstIcon} onClick={() => handlePassword(isVisible)} />
          </LoginInput>
          <LoginInput>
            <LockIcon src={lockSvg} />
            <Input type={isHidden} placeholder={t('resetPassword.form.confirmPassword')} />
            <EyeIcon src={secIcon} onClick={() => handleConfirmPassword(isHidden)} />
          </LoginInput>
          <ResetPassSubmitButton type="submit">{t('resetPassword.form.button')}</ResetPassSubmitButton>
        </FlexContainer>
        <FooterContainer>
          <FooterText>{t('signUp.footer.rights')}</FooterText>
          <LinkContainer>
            <FooterLink href="/">{t('resetPassword.footer.termsOfUse')}</FooterLink>
            <FooterLink href="/">{t('resetPassword.footer.privacyPolicy')}</FooterLink>
          </LinkContainer>
        </FooterContainer>
      </FormContainer>
      <ImageContainer>
        <BackgroundImage src={resetImg} alt="Background image" />
      </ImageContainer>
    </Container>
  );
};

export default PasswordReset;
